<template>
  <div>
    <Head :title="__('Users')" />
      <div class="flex flex-col items-center justify-between gap-3 mb-6 md:flex-row ticket-filters">
          <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
          <div class="flex flex-col items-center w-full max-w-md gap-3 filter-add-new md:flex-row">
              <select-input v-model="form.role_id" class="w-full mr-2 ">
                  <option :value="null">{{ __('Filter by role') }}</option>
                  <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
              </select-input>
              <Link class="btn-indigo" :href="route('users.create')">
                  <span>{{ __('Create New') }}</span>
              </Link>
          </div>
      </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Email') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Phone') }}</th>
              <th class="px-6 pt-6 pb-4">{{ __('Country') }}</th>
              <th class="px-6 pt-6 pb-4">{{ __('City') }}</th>
              <th class="px-6 pt-6 pb-4" colspan="2">{{ __('Role') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users.data" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="route('users.edit', user.id)">
                <img v-if="user.photo" class="block w-5 h-5 mr-2 -my-2 rounded-full" :src="user.photo" />
                {{ user.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                {{ user.email }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                {{ user.phone }}
              </Link>
            </td>
              <td class="border-t">
                  <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                      {{ __(user.country) }}
                  </Link>
              </td>
              <td class="border-t">
                  <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                      {{ __(user.city) }}
                  </Link>
              </td>
            <td class="capitalize border-t">
              <Link class="flex items-center px-6 py-4" :href="route('users.edit', user.id)" tabindex="-1">
                {{ user.role?user.role.name:null }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="route('users.edit', user.id)" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="users.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="6">No users found.</td>
          </tr>
        </tbody>
      </table>
    </div>
      <pagination class="mt-6" :links="users.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
      SearchInput,
    Head,
    Icon,
    Link,
      SelectInput,
      Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    roles: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role_id: this.filters.role_id ?? null,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('users'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
